/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationChoice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ButtonVisitChoice from 'DesignSystem/ButtonVisitChoice/index'
import LocationMarker from 'DesignSystem/Svgs/LocationMarker/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LocationChoice({
  children,
  viewPath = "/DesignSystem/LocationChoice",
  onMouseEnter,
  onMouseLeave,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  onClick,
  innerRef,
  isSelected,
  backgroundColorSelected,
  borderColorSelected,
  backgroundColorHovered,
  borderColorHovered,
  isHighlighted,
  backgroundColorHighlighted,
  borderColorHighlighted,
  locationName = "",
  text = "Little Rock, AR",
  colorSelected,
  colorHovered,
  colorHighlighted,
  subtext = "401 Rocky Street",
  hasDistance,
  distance = "10m",
  hasVirtual,
  buttonBackgroundColorHovered,
  buttonBorderColorHovered,
  buttonBackgroundColorSelected,
  buttonBorderColorSelected,
  buttonBorderColor = "#e5e5e5",
  buttonColor = "#323232",
  buttonColorHovered,
  buttonColorSelected = "#ffffff",
  onSelect,
  id,
  selected,
  selectedLocationVisitType,
  parentViewPath,
  hasInPerson
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave,isSelected})
  let isMedia = useIsMedia()
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsGreen700alpha15 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.15'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsGreen700alpha5 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.5'
        })
let backgroundColorHighlightedOrdtColorsGreen700alpha15 = backgroundColorHighlighted ?? dtColorsGreen700alpha15
let backgroundColorHoveredOrdtColorsGreen700alpha5 = backgroundColorHovered ?? dtColorsGreen700alpha5
let backgroundColorSelectedOrdtColorsGreen700alpha15 = backgroundColorSelected ?? dtColorsGreen700alpha15
let borderColorHighlightedOrdtColorsGreen700 = borderColorHighlighted ?? dtColorsGreen700
let borderColorHoveredOrdtColorsGreen700 = borderColorHovered ?? dtColorsGreen700
let borderColorSelectedOrdtColorsGreen700 = borderColorSelected ?? dtColorsGreen700
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontweightBold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.bold'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let colorHighlightedOrdtColorsGreen700 = colorHighlighted ?? dtColorsGreen700
let colorHoveredOrdtColorsGreen700 = colorHovered ?? dtColorsGreen700
let colorSelectedOrdtColorsGreen700 = colorSelected ?? dtColorsGreen700
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
let colorHighlightedOrdtColorsGreen7001 = colorHighlighted ?? dtColorsGreen700
let colorHoveredOrdtColorsGreen7001 = colorHovered ?? dtColorsGreen700
let colorSelectedOrdtColorsGreen7001 = colorSelected ?? dtColorsGreen700
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let colorHighlightedOrdtColorsGreen7002 = colorHighlighted ?? dtColorsGreen700
let colorHoveredOrdtColorsGreen7002 = colorHovered ?? dtColorsGreen700
let colorSelectedOrdtColorsGreen7002 = colorSelected ?? dtColorsGreen700
let dtColorsGreen700alpha83 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.83'
        })
  return (<React.Fragment
>
<div
  data-testid="LocationChoice.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 className="views-block"
>
<div
  data-testid="LocationChoice.Vertical:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 ref={innerRef}
 style={{'--bblr-2-Z1XWmtx': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z1XWmtx': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1XWmtx': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1XWmtx': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mb-7-Z1XWmtx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-9-Z1XWmtx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-Z1XWmtx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-11-Z1XWmtx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-12-Z1XWmtx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-1-Z1XWmtx': isSelected ? backgroundColorSelectedOrdtColorsGreen700alpha15 : isHovered ? backgroundColorHoveredOrdtColorsGreen700alpha5 : isHighlighted ? backgroundColorHighlightedOrdtColorsGreen700alpha15 : "#ffffff",'--bc-4-Z1XWmtx': isSelected ? borderColorSelectedOrdtColorsGreen700 : isHovered ? borderColorHoveredOrdtColorsGreen700 : isHighlighted ? borderColorHighlightedOrdtColorsGreen700 : "#ebebeb",'--h-14-Z1XWmtx': isMedia.mobile ? "130px" : "auto",'--w-13-Z1XWmtx': isMedia.mobile ? "230px" : "200px",'--mr-8-Z1XWmtx': isMedia.mobile ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="LocationChoice.Text"
  data-view-path={viewPath}
 style={{'--c-15-Z1XWmtx': dtColorsNeutral700,'--fs-16-Z1XWmtx': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-17-Z1XWmtx': dtTypographyFontweightBold}}
 className={`views-text ${styles.Text}`}
>
{locationName}
</span>
<span
  data-testid="LocationChoice.Text:1"
  data-view-path={viewPath}
 style={{'--fs-16-Z1XWmtx': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-17-Z1XWmtx': dtTypographyFontweightRegular,'--c-15-Z1XWmtx': isSelected ? colorSelectedOrdtColorsGreen700 : isHovered ? colorHoveredOrdtColorsGreen700 : isHighlighted ? colorHighlightedOrdtColorsGreen700 : dtColorsNeutral700}}
 className={`views-text ${styles.Text1}`}
>
{text}
</span>
<span
  data-testid="LocationChoice.Text:2"
  data-view-path={viewPath}
 style={{'--fs-16-Z1XWmtx': typeof dtTypographyFontsizeS === 'number' ? `${dtTypographyFontsizeS}px` : dtTypographyFontsizeS,'--fw-17-Z1XWmtx': dtTypographyFontweightRegular,'--c-15-Z1XWmtx': isSelected ? colorSelectedOrdtColorsGreen7001 : isHovered ? colorHoveredOrdtColorsGreen7001 : isHighlighted ? colorHighlightedOrdtColorsGreen7001 : dtColorsNeutral700}}
 className={`views-text ${styles.Text2}`}
>
{subtext}
</span>
<div
  data-testid="LocationChoice.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-19-Z1XWmtx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--jc-18-Z1XWmtx': hasDistance ? "space-between" : "flex-end"}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={hasDistance}>
<div
  data-testid="LocationChoice.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<LocationMarker
  viewPath={`${viewPath}/LocationMarker`}
 width={12}
 height={12}
 fill="#161616"
/>
<span
  data-testid="LocationChoice.Text:3"
  data-view-path={viewPath}
 style={{'--ml-20-Z1XWmtx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--fs-16-Z1XWmtx': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-17-Z1XWmtx': dtTypographyFontweightRegular,'--c-15-Z1XWmtx': isSelected ? colorSelectedOrdtColorsGreen7002 : isHovered ? colorHoveredOrdtColorsGreen7002 : isHighlighted ? colorHighlightedOrdtColorsGreen7002 : "#161616"}}
 className={`views-text ${styles.Text3}`}
>
{distance}
</span>
</div>
</fromFlow.When>
</div>
<div
  data-testid="LocationChoice.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-19-Z1XWmtx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<fromFlow.When is={hasVirtual}>
<ButtonVisitChoice
  viewPath={`${viewPath}/ButtonVisitChoice`}
 backgroundColorHovered={buttonBackgroundColorHovered}
 borderColorHovered={buttonBorderColorHovered}
 backgroundColorSelected={buttonBackgroundColorSelected}
 borderColorSelected={buttonBorderColorSelected}
 borderColor={buttonBorderColor}
 color={buttonColor}
 colorHovered={buttonColorHovered || dtColorsGreen700alpha83}
 colorSelected={buttonColorSelected}
 marginTop={0}
 width="auto"
 onClick={onSelect}
 id={id}
 locationVisitType="virtual"
 selected={selected}
 selectedLocationVisitType={selectedLocationVisitType}
 parentViewPath={parentViewPath}
 text="Virtual Visit"
/>
</fromFlow.When>
<fromFlow.When is={hasInPerson}>
<ButtonVisitChoice
  viewPath={`${viewPath}/ButtonVisitChoice`}
 backgroundColorHovered={buttonBackgroundColorHovered}
 borderColorHovered={buttonBorderColorHovered}
 backgroundColorSelected={buttonBackgroundColorSelected}
 borderColorSelected={buttonBorderColorSelected}
 borderColor={buttonBorderColor}
 color={buttonColor}
 colorHovered={buttonColorHovered || dtColorsGreen700alpha83}
 colorSelected={buttonColorSelected}
 width="auto"
 marginTop={0}
 marginLeft={4}
 onClick={onSelect}
 id={id}
 locationVisitType="inPerson"
 selected={selected}
 selectedLocationVisitType={selectedLocationVisitType}
 parentViewPath={parentViewPath}
 text="In Person"
/>
</fromFlow.When>
</div>
</div>
</div>
{children}
</React.Fragment>)
}